module.exports = "/assets/landing-rc/cuisines/18.jpg?m680MkB";